<template>
  <div style="min-height: 400px;">
    <div class="menuSearch">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <span
            class="nav-link pointer"
            @click="showTab(true)"
            :class="{ active: tabSearch }"
            aria-current="page"
          >
            Pesquisa
          </span>
        </li>
        <li class="nav-item hide">
          <span
            class="nav-link pointer"
            @click="showTab(false)"
            :class="{ active: tabRecent }"
          >
            Recente
          </span>
        </li>
      </ul>
    </div>
    <div class="row p-3 pb-0">
      <div
        class="col-lg-12 col-xs-12"
        v-if="tabSearch"
      >
        <label class="p-0 m-0">Requerido (and)</label>
        <VueTagsInput
          v-model="terms_requireds"
          class="full"
          :tags="search.terms_requireds"
          @adding-duplicate="$toast.error('Esta tag já foi inserida')"
          @tags-changed="(newTags) => (search.terms_requireds = newTags)"
        />
      </div>
      <div
        class="col-lg-6 mt-2 col-xs-12"
        v-if="tabSearch"
      >
        <label class="p-0 m-0">Opcional(or)</label>
        <VueTagsInput
          v-model="terms_optionals"
          class="full"
          :tags="search.terms_optionals"
          @adding-duplicate="$toast.error('Esta tag já foi inserida')"
          @tags-changed="
            (new_optional) => (search.terms_optionals = new_optional)
          "
        />
      </div>
      <div
        class="col-lg-6 mt-2 col-xs-12"
        v-if="tabSearch"
      >
        <label class="p-0 m-0">Excluido(not)</label>
        <VueTagsInput
          v-model="terms_excluded"
          class="full"
          :tags="search.terms_excluded"
          @adding-duplicate="$toast.error('Esta tag já foi inserida')"
          @tags-changed="(new_not) => (search.terms_excluded = new_not)"
        />
      </div>
    </div>
    <div
      v-if="data_suggestion.search == true"
      class="row p-3 pt-1"
    >
      <div class="col-lg-12">
        <label class="f16"> <b> Sugestão</b> </label>
      </div>
      <div
        v-for="field in field_suggestion"
        :key="field['field']+ 'suggestion'"
        class="col-lg-12 col-xs-12 mt-4"
      >

        <label>{{ field["name"] }}</label>
        <div>
          <div
            v-for=" (agg, index) in data_suggestion[field['field']]['buckets']"
            :key="index+'agg_item'"
          >
            <AggItem
              v-if="index < 30 && agg.key != ''"
              :doc_count="agg.doc_count"
              :key_name="agg.key"
              @populationTerms="populationTerms"
            />
          </div>
        </div>

      </div>
    </div>

    <div class="row p-3">
      <div class="col-lg-12 col-xs-12">
        <p>Critérios adicionais</p>
      </div>
      <div class="col-lg-12 col-xs-12">
        <div
          v-for="(amount, amount_index) in amount_sub_search"
          :key="amount_index+'amount'"
          class="row pt-2 pb-2"
        >
          <div class="col-lg-3 col-xs-12">
            <multiselect
              v-model="sub_search_selected[amount_index]"
              deselect-label="Can't remove this value"
              track-by="name"
              label="name"
              :maxHeight="120"
              placeholder="Selecione um"
              :options="sub_search"
              :searchable="true"
              :show-labels="false"
              :allow-empty="false"
            >
              <template
                slot="singleLabel"
                slot-scope="{ option }"
              >{{ option.name }}</template>
            </multiselect>

          </div>
          <div
            v-if="sub_search_selected[amount_index]"
            class="col-lg-3 col-xs-12"
          >

            <multiselect
              v-model="sub_search_options[amount_index]"
              deselect-label="Can't remove this value"
              track-by="name"
              label="name"
              placeholder="Selecione um"
              :options="data_settings[sub_search_selected[amount_index].type]"
              :searchable="true"
              :show-labels="false"
              :allow-empty="false"
            >
              <template
                slot="singleLabel"
                slot-scope="{ option }"
              >{{ option.name }}</template>
            </multiselect>

          </div>
          <div
            v-if="sub_search_options[amount_index]"
            class="col-lg-5 col-xs-12"
          >
            <input
              type="text"
              class="form-control"
              v-if="sub_search_selected[amount_index].type == 'timestamp'"
              v-mask="'##/##/####'"
              v-model="sub_search_value[amount_index]"
            />
            <input
              type="text"
              v-if="sub_search_selected[amount_index].type == 'string'"
              class="form-control"
              v-model="sub_search_value[amount_index]"
            />

            <multiselect
              v-if="sub_search_selected[amount_index].type == 'array'"
              v-model="sub_search_value[amount_index]"
              deselect-label="Can't remove this value"
              placeholder="Selecione um"
              :options="sub_search_selected[amount_index]['data']"
              :searchable="true"
              :allow-empty="false"
              :show-labels="false"
              :multiple="true"
            >
              <template slot-scope="{ option }">{{ option }}</template>
            </multiselect>

            <multiselect
              :id="'multi'+amount_index"
              v-if="sub_search_selected[amount_index].type == 'autocomplete'"
              v-model="sub_search_value[amount_index]"
              :track-by="sub_search_selected[amount_index]['track']"
              :label="sub_search_selected[amount_index]['track']"
              open-direction="bottom"
              :options="sub_search_selected[amount_index]['data']"
              :multiple="true"
              :searchable="true"
              :loading="isLoading"
              :internal-search="false"
              :clear-on-select="true"
              :close-on-select="false"
              :options-limit="100"
              :limit="3"
              :max-height="400"
              :show-no-results="false"
              :hide-selected="true"
              @search-change="asyncFind($event ,amount_index)"
            >

              <template slot-scope="{ option }">{{ option }}</template>
            </multiselect>
            <div
              class="row"
              v-if="sub_search_selected[amount_index].type == 'float'"
            >
              <div class="col-lg-6 col-xs-12">
                <currency-input
                  class="form-control"
                  v-model="sub_search_value[amount_index]"
                  placeholder="0,00"
                />
              </div>
              <div
                v-show="sub_search_options[amount_index]['comparation']"
                class="col-lg-6 col-xs-12"
              >
                <currency-input
                  v-model="sub_search_value_other[amount_index]"
                  class="form-control"
                  placeholder="0,00"
                />
              </div>

            </div>

          </div>
          <div class="col-lg-1 col-xs-12">
            <button
              type="button"
              v-if="sub_search_options[amount_index]"
              @click="removeItemSubQuery(amount_index)"
              class="btn btn-secondary"
            >
              <font-awesome-icon icon="times" />
            </button>
          </div>
        </div>

      </div>
      <div class="col-lg-12  col-xs-12">
        <button
          @click="addAmountSearch()"
          type="button"
          class="btn mt-3 btn-primary"
        >
          <font-awesome-icon
            class="mr-2"
            icon="plus"
          />Adicionar critério
        </button>
      </div>
    </div>
    <div class="row p-3">
      <div class="col-lg-12">
        <button
          @click="submitSearch"
          class="btn btn-primary right"
          type="button"
        >
          Pesquisar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { state, gettersMap, mutationsMap } from "store/table.js";
import VueTagsInput from "@johmun/vue-tags-input";
import { format } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import AggItem from "components/Search/AggItem.vue";
import Multiselect from "vue-multiselect";
export default {
  props: ["url_suggestion", "field_suggestion", "sub_search"],
  components: { VueTagsInput, AggItem, Multiselect },
  data: () => ({
    isLoading: false,
    tabSearch: true,
    tabRecent: false,
    data_suggestion: {
      search: false,
    },
    state: state,
    terms_requireds: "",
    terms_optionals: "",
    terms_excluded: "",
    amount_sub_search: [0],
    sub_search_selected: [],
    sub_search_options: [],
    sub_search_value: [],
    sub_search_value_other: [],
    search: {
      terms_requireds: [],
      terms_optionals: [],
      terms_excluded: [],
    },
  }),
  computed: {
    data_settings() {
      return {
        string: [
          {
            name: "Começar com",
            operator: '{"__field__": { "like": "__data__%" }}',
          },
          {
            name: "Termina com",
            operator: '{"__field__": { "like": "%__data__" }}',
          },
          {
            name: "Contem a palavra",
            operator: '{"__field__": { "like": "%__data__%" }}',
          },
        ],
        timestamp: [
          {
            name: "Maior que",
            operator: '{"__field__": { "gte": "__data__" }}',
          },
          {
            name: "Menor que",
            operator: '{"__field__": { "lte": "__data__" }}',
          },
          { name: "Igual à", operator: '{"__field__": "__data__" }' },
        ],
        array: [
          {
            name: "Todos Inclusos",
            operator: '{"__field__": __data__}',
          },
          {
            name: "Excluir",
            operator: '{"__field__": { "not": "__data__" }}',
          },
        ],
        autocomplete: [
          {
            name: "Todos Inclusos",
            operator: '{"__field__": __data__}',
          },
          {
            name: "Excluir",
            operator: '{"__field__": { "not": "__data__" }}',
          },
        ],
        float: [
          {
            name: "Maior que",
            operator: '{"__field__": { "gte": "__data__" }}',
          },
          {
            name: "Menor que",
            operator: '{"__field__": { "lte": "__data__" }}',
          },
          { name: "Igual à", operator: '{"__field__": "__data__" }' },
          {
            name: "Entre",
            comparation: true,
            operator:
              '{"__field__": { "gte": "__data__",  "lte": "__data2__"  }}',
          },
        ],
      };
    },
  },
  watch: {
    "search.terms_requireds"(new_state) {
      this.suggestion();
    },
  },
  mounted() {
    this.populationSearch();
    this.populationSubSearch();
  },
  methods: {
    asyncFind(query, amount) {
      this.isLoading = true;

      axios
        .get(this.sub_search_selected[amount]["url"] + "?term=" + query)
        .then((response) => {
          if (!this.sub_search_value[amount]) {
            this.sub_search_value[amount] = [];
          }
          this.sub_search_selected[amount]["data"] =
            response.data[this.sub_search_selected[amount]["term_search"]];
          this.isLoading = false;
        });
    },
    onSelect(items, lastSelectItem) {
      alert(items);
    },
    addAmountSearch() {
      this.amount_sub_search.push(this.amount_sub_search.length);
    },
    populationSearch() {
      this.populationTerms(gettersMap.getTermsRequireds(), "terms_requireds");
      this.populationTerms(gettersMap.getTermsOptionals(), "terms_optionals");
      this.populationTerms(gettersMap.getTermsExcluded(), "terms_excluded");
    },
    populationSubSearch() {
      this.sub_search_selected = gettersMap.getSubSearchSelected();
      this.sub_search_options = gettersMap.getSubSearchOptions();
      this.sub_search_value = gettersMap.getSubSearchValue();
      this.sub_search_value_other = gettersMap.getSubSearchValueOther();
      this.amount_sub_search = gettersMap.getAmountSubSearch();
    },
    populationTerms(term, terms_operator) {
      if (term) {
        for (let i in term) {
          if (!this.search[terms_operator].includes(term[i])) {
            this.search[terms_operator].push({
              text: term[i],
              tiClasses: ["ti-valid"],
            });
          }
        }
      }
    },
    showTab(menu) {
      if (menu) {
        this.tabSearch = true;
        this.tabRecent = false;
        return;
      }

      this.tabSearch = false;
      this.tabRecent = true;
    },
    buildTerms(terms) {
      let terms_builder = [];
      if (this.search[terms] != "") {
        for (let i in this.search[terms]) {
          terms_builder.push(this.search[terms][i]["text"]);
        }
      }

      if (this[terms] != "") {
        terms_builder.push(this[terms]);
      }
      return terms_builder;
    },
    suggestion() {
      let params = {};

      params["search"] = this.buildParams().join(",");

      axios.get(this.url_suggestion, { params: params }).then((response) => {
        this.data_suggestion = { search: false };
        for (let i in this.field_suggestion) {
          if (!this.data_suggestion[this.field_suggestion[i]["field"]]) {
            this.data_suggestion[this.field_suggestion[i]["field"]] = [];
          }

          this.data_suggestion[this.field_suggestion[i]["field"]] =
            response.data.aggregators[this.field_suggestion[i]["field"]];
        }
        this.data_suggestion.search = true;
      });
    },
    buildParams() {
      mutationsMap.setTermsRequired(this.buildTerms("terms_requireds"));
      mutationsMap.setTermsOptionals(this.buildTerms("terms_optionals"));
      mutationsMap.setTermsExcluded(this.buildTerms("terms_excluded"));
      let terms_requireds = this.buildTerms("terms_requireds").map(
        (terms) => "+" + terms
      );
      let terms_not = this.buildTerms("terms_excluded").map(
        (terms) => "-" + terms
      );
      let term_search = terms_requireds
        .concat(this.buildTerms("terms_optionals"))
        .concat(terms_not);
      return term_search;
    },
    buildWhere() {
      mutationsMap.setWhere({});
      let query = { _and: [] };
      if (!this.sub_search_options[0]) {
        return [];
      }
      for (let i in this.sub_search_selected) {
        let operator = this.sub_search_options[i].operator;
        let data_value = this.sub_search_value[i];

        if (this.sub_search_selected[i]["type"] == "timestamp") {
          data_value = data_value.split("/");
          data_value = format(
            new Date(data_value[2], data_value[1], data_value[0]),
            "yyyy-MM-dd",
            {
              locale: ptBR,
            }
          );
        }

        if (this.sub_search_selected[i]["type"] == "array") {
          let new_value = data_value.map((value) => {
            return '"' + value + '"';
          });
          data_value = "[" + new_value.join(",") + "]";
        }

        if (this.sub_search_selected[i]["type"] == "autocomplete") {
          let new_value = data_value.map((value) => {
            return '"' + value[this.sub_search_selected[i]["track"]] + '"';
          });
          data_value = "[" + new_value.join(",").toLowerCase() + "]";
        }

        if (this.sub_search_selected[i]["type"] == "float") {
          operator = operator.replaceAll("__data__", data_value);
          operator = operator.replaceAll(
            "__data2__",
            this.sub_search_value_other[i]
          );
        } else {
          operator = operator.replaceAll("__data__", data_value);
        }

        operator = operator.replaceAll(
          "__field__",
          this.sub_search_selected[i]["field"]
        );

        query["_and"].push(JSON.parse(operator));
      }

      return query;
    },
    removeItemSubQuery(index) {
      let conf = confirm("Tem certeza que deseja deletar esse item da busca?");
      if (!conf) return;
      this.amount_sub_search.splice(index, 1);
      this.sub_search_selected.splice(index, 1);
      this.sub_search_options.splice(index, 1);
      this.sub_search_value.splice(index, 1);
      if (this.sub_search_value_other[index]) {
        this.sub_search_value_other.splice(index, 1);
      }
    },
    setSubSearch() {
      mutationsMap.setSubSearchValue = this.sub_search_value;
      mutationsMap.setSubSearchValue = this.sub_search_value_other;
      mutationsMap.setSubSearchOptions = this.sub_search_options;
      mutationsMap.setSubSearchSelected = this.sub_search_Selected;
      mutationsMap.setAmountSubSearch = this.amount_sub_search;
    },
    submitSearch() {
      mutationsMap.setTermsSearch(this.buildParams());
      let where = this.buildWhere();
      if (Object.keys(where).length !== 0) {
        mutationsMap.setWhere(where);
      }
      mutationsMap.setSearchFlag();
      this.$modal.hideAll();
    },
  },
};
</script>
